import * as actionTypes from './FormActionTypes';

const initialState = {
  amount: null,
  reAmount: null,
  city: null,
  stateLocale: null,
  zip: null,
  street: null,
  street2: null,
  notes: null,
  fieldOffice: null,
};

const FormReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.SET_AMOUNT:
      return {
        ...state,
        amount: payload,
      };
    case actionTypes.SET_RE_AMOUNT:
      return {
        ...state,
        reAmount: payload,
      };
    case actionTypes.SET_CITY:
      return {
        ...state,
        city: payload,
      };
    case actionTypes.SET_STATELOCALE:
      return {
        ...state,
        stateLocale: payload,
      };
    case actionTypes.SET_ZIP:
      return {
        ...state,
        zip: payload,
      };
    case actionTypes.SET_STREET:
      return {
        ...state,
        street: payload,
      };
    case actionTypes.SET_STREET_2:
      return {
        ...state,
        street2: payload,
      };
    case actionTypes.SET_NOTES:
      return {
        ...state,
        notes: payload,
      };
    case actionTypes.SET_OFFICE:
      return {
        ...state,
        fieldOffice: payload,
      };
    default:
      return state;
  }
};

export default FormReducer;
